<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="content-management" class="data-list-container">

    <div class="flex flex-wrap-reverse items-center data-list-btn-container">

      <v-select name="user_group" class="marketing-dropdown"
                v-model="content_type" :options="content_type_options" :clearable="false" @input="onTypeChange"></v-select>
    </div>

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" :contentTypeRemote="this.content_type.value"/>
    <add-blog-sidebar :isSidebarActive="addNewBlogSidebar" @closeSidebar="toggleBlogSidebar" :data="blogsidebarData" />

    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="contents">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">


          <div v-if="this.content_type.value!=='blog'" class="marketing-button" @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="">Add New</span>
          </div>
          <div v-if="this.content_type.value==='blog'" class="marketing-button" @click="addNewBlog">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="">Add Blog</span>
          </div>

        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ contents.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : contents.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="image">Image</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="category">Type</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          
          <vs-td class="img-container">
            <img :src="tr.contentImageUrl" class="product-img" />
          </vs-td>

          <vs-td>
            <p class="product-category">{{ tr.name | title }}</p>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ tr.contentType | title }}</p>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="confirmDelete(tr.id)" />
          </vs-td>

        </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import AddBlogSidebar from './AddBlogSidebar'
import vSelect from 'vue-select'

export default {
  components: {
    DataViewSidebar,
    AddBlogSidebar,
    vSelect
  },
  data () {
    return {
      selected: [],
      // products: [],
      itemsPerPage: 10,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      addNewBlogSidebar: false,
      sidebarData: {},
      blogsidebarData: {},
      content_type: {label: 'Deals Section Thumbnails', value: 'page'},
      content_type_options: [
        {label: 'Deals Section Thumbnails', value: 'page'},
        {label: 'Main Page Slider', value:'slide'},
        {label: 'Special Deals', value:'campaign'},
        {label: 'Blog', value:'blog'},
        {label: 'Coupons Page Ads', value:'coupon-banner'},
        {label: 'Coupons Page Slider', value:'coupon-slider'},
        {label: 'Special Deals Page Slider', value:'special-slider'},
        {label: 'Events Page Slider', value:'event-slider'}
      ],
      contentType: 'slide'
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.contents.length
    },
    contentList () {
      const contents = this.$store.state.api.contents
      return contents.reverse()
    },
    contents () {
      return this.$store.state.api.contents.slice().reverse()
    }
  },
  watch: {
  },
  methods: {
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    addNewBlog () {
      this.blogsidebarData = { add: true }
      this.toggleBlogSidebar(true)
    },
    confirmDelete (id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure to delete this item?',
        clickNotClose: true,
        accept: this.deleteData,
        parameters: [id],
        acceptText: 'Delete'
      })
    },
    deleteData (id) {
      this.$vs.loading()
      const payload = {
        contentId: id
      }
      this.$store.dispatch('api/removeContents', payload).then(() => {
        this.$vs.notify({
          title: 'Delete',
          text: 'Item deleted succesfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.getContentList()
        this.$vs.loading.close()
      }).catch(err => {
        this.$vs.loading.close()
        console.error(err)
      })
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      if (this.content_type.value !== 'blog') {
        this.sidebarData = data
        this.toggleDataSidebar(true)
      } else {
        this.blogsidebarData = data
        this.toggleBlogSidebar(true)
      }
    },
    toggleDataSidebar (val = false) {
      if (!val) {
        this.getContentList()
      }
      this.addNewDataSidebar = val
    },
    toggleBlogSidebar (val = false) {
      if (!val) {
        this.getContentList()
      }
      this.addNewBlogSidebar = val
    },
    getContentList () {
      const payload = {
        contentType: this.content_type.value,
        page: 1,
        isHome: 1,
        limit:20
      }

      this.$vs.loading()

      this.$store.dispatch('api/getContents', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    onTypeChange () {
      this.getContentList()
    }
  },
  created () {
  },
  mounted () {
    this.isMounted = true
    this.getContentList()
  }
}
</script>
